<template>
  <a-modal title="退菜" :visible="visible" :maskClosable="false" width="480px"
           :confirm-loading="loading" ok-text="确认退菜" ok-type="danger"
           @ok="onOk" @cancel="$emit('cancel')">
    <div class="ri-tip">
      退菜需填写理由（必填），确认后该菜品金额不再计入账单，<br>并将打印退菜单通知厨房与传菜部。
    </div>
    <div v-if="itemName" class="ri-item">
      <span class="ri-item-label">退菜菜品</span>
      <span class="ri-item-name">{{ itemName }}</span>
    </div>
    <div class="ri-field">
      <span class="ri-label"><i class="req">*</i>退菜理由</span>
      <a-select v-model="reason" placeholder="请选择常用退菜理由" style="width: 100%"
                :getPopupContainer="trigger => trigger.parentElement" allowClear>
        <a-select-option v-for="r in reasons" :key="r" :value="r">{{ r }}</a-select-option>
      </a-select>
    </div>
    <div class="ri-field">
      <span class="ri-label">自定义理由</span>
      <a-input v-model="customReason" placeholder="或直接输入自定义理由（优先于下拉选择）" :maxLength="100" />
    </div>
  </a-modal>
</template>

<script>
/**
 * 退菜理由弹窗（dining-print-architecture Task 8，TableView/FastfoodView 共用）：
 * 常用理由下拉 + 自定义输入（自定义优先），理由必填；确认后由父组件调
 * POST /order/{id}/item/{itemId}/return（触发 TCD 退菜单打印）。
 */
const REASONS = [
  '顾客不要了', '点错了', '上菜太慢，顾客取消', '菜品质量问题', '做错了菜品',
  '重复下单', '菜品估清无法制作', '顾客口味不合', '等位太久退菜', '其他原因'
]

export default {
  name: 'ReturnItemModal',
  props: {
    visible: { type: Boolean, default: false },
    itemName: { type: String, default: '' },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      reason: undefined,
      customReason: '',
      reasons: REASONS
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.reason = undefined
        this.customReason = ''
      }
    }
  },
  methods: {
    onOk() {
      const reason = (this.customReason || '').trim() || this.reason
      if (!reason) {
        this.$message.warning('请选择或输入退菜理由')
        return
      }
      this.$emit('confirm', reason)
    }
  }
}
</script>

<style scoped>
.ri-tip {
  font-size: 13px;
  color: #e4632a;
  line-height: 1.7;
  margin-bottom: 14px;
}
.ri-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
  padding: 8px 12px;
  background: #f6f8fa;
  border-radius: 6px;
}
.ri-item-label {
  font-size: 13px;
  color: #98a0aa;
  flex-shrink: 0;
}
.ri-item-name {
  font-size: 15px;
  font-weight: 600;
  color: #262b33;
}
.ri-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 12px;
}
.ri-label {
  font-size: 13px;
  color: #4a5261;
}
.req {
  color: #f5222d;
  font-style: normal;
  margin-right: 2px;
}
</style>
